import { render, staticRenderFns } from "./DashboardTitle.vue?vue&type=template&id=3cf29d00&scoped=true&"
import script from "./DashboardTitle.vue?vue&type=script&lang=js&"
export * from "./DashboardTitle.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTitle.vue?vue&type=style&index=0&id=3cf29d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf29d00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
